import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, IconButton, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import React from "react";
import { useAccessibility } from "../../Store/contexts/AccessibilityContext";
import checkIcon from "../../assets/images/circle-check.png";
import errorIcon from "../../assets/images/octagon-xmark.svg";
import warningIcon from "../../assets/images/triangle-exclamation.png";
import infoIcon from "../../assets/images/circle-info.png";
import { ModalFeedBackProps } from "../../interfaces/props/ModalFeedBackProps";
import "./styles.css";
import {
  sxButton,
  sxButtonContained,
  sxCloseIconButton,
  sxModal,
  sxTextButton,
  sxTextButtonContained,
  sxTypographySubTitle,
  sxTypographyTitle,
} from "./sxProps";
import parse from "html-react-parser";

const ModalFeedBack: React.FC<ModalFeedBackProps> = ({
  showModal,
  handleShowModal,
  icon,
  textButton,
  title,
  subTitle,
  showButtonModal,
  handleButtonModal,
  classNameModal,
}) => {
  const selecionarIcone = (icon: "error" | "success" | "warning" | "info"): string => {
    switch (icon) {
      case "success":
        return checkIcon;
      case "error":
        return errorIcon;
      case "warning":
        return warningIcon;
      case "info":
        return infoIcon;
      default:
        return checkIcon;
    }
  };

  const selecionarTipoBotao = (
    icon: "error" | "success" | "warning" | "info"
  ): string => {
    switch (icon) {
      case "success":
      case "warning":
        return "contained";
      case "error":
        return "outlined";
      default:
        return "contained";
    }
  };

  const accessibility = useAccessibility();

  return (
    <div>
      <Modal open={showModal ? showModal : false} onClose={handleShowModal}>
        <Box
          sx={sxModal}
          style={{
            ...accessibility.textStyleAccessibility,
            ...accessibility.contrastBorderAccessibility,
          }}
          className={classNameModal}
        >
          <IconButton
            aria-label="Fechar mensagem de status"
            onClick={handleShowModal}
            style={accessibility.buttonStyleAccessibility}
            sx={sxCloseIconButton}
          >
            <FontAwesomeIcon icon={faTimes} size="1x" color="black" />
          </IconButton>
          {icon !== "none" && (
            <div className="modal-feedback-icon-holder">
              <img
                src={selecionarIcone(icon)}
                alt={""}
                className="container-modal-feedback-image"
              />
            </div>
          )}
          {title && <Typography component="h1" sx={sxTypographyTitle}>{title}</Typography>}
          {subTitle && (
            <Typography sx={sxTypographySubTitle} className="feedback">
             {typeof subTitle === "string" ? parse(subTitle) : subTitle}
            </Typography>
          )}
          {showButtonModal && icon !== "none" && (
            <div className="modal-feedback-buttons-holder">
              <Button
                style={accessibility.buttonStyleAccessibility}
                onClick={handleButtonModal}
                sx={
                  selecionarTipoBotao(icon) === "contained"
                    ? sxButtonContained
                    : sxButton
                }
                variant={selecionarTipoBotao(icon) as any}
              >
                <Typography
                  style={accessibility.buttonTextStyleAccessibility}
                  sx={
                    selecionarTipoBotao(icon) === "contained"
                      ? sxTextButtonContained
                      : sxTextButton
                  }
                >
                  {textButton}
                </Typography>
              </Button>
            </div>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default ModalFeedBack;
